/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PasskeyRegistrationVerifyForm { 
    /**
     * Attestation object WebAuthn, codificato in Base64URL
     */
    attestation_object: string;
    /**
     * Client data JSON WebAuthn, codificato in Base64URL
     */
    client_data_json: string;
    /**
     * Nome descrittivo del dispositivo (es. \'iPhone di Mario\')
     */
    display_name?: string;
    /**
     * Refresh token KC offline da associare alla passkey
     */
    refresh_token: string;
}

